import {
  Pagination,
  Spin,
  Select,
  Collapse,
  Input,
  Result,
  Button,
  Popconfirm,
} from "antd";
import { useQuery } from "react-query";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../config/axios-instance";
import { LoadingOutlined, FilterOutlined } from "@ant-design/icons";
import avatar from "../../img/avatar_placeholder.jpg";
import moment from "moment";
import { useMutation } from "react-query";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import { useState } from "react";
import {
  deleteCustomizedOrder,
  restoreCustomizedOrder,
} from "../../actions/my-orders/services";

const { Option } = Select;
const { Panel } = Collapse;

const CustomizedOrdersCompany = () => {
  const [filterBy, setFilterBy] = useState({
    reference: "",
    client: 0,
    type: 0,
  });
  const [orders, setOrders] = useState<any>(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [ordersCancel, serOrdersCancel] = useState<any>(null);

  const params = useParams<any>();
  const history = useHistory<any>();

  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQueryy();

  const fetchCustomizedOrders = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/admin/customized_products/companies/${params.id}?page=${
        query.get("page") || 1
      }`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => setOrders(res.data));
  };

  const fetchClients = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/admin/clients/companies/${params.id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const { isLoading: loading, data: clients } = useQuery<any>(
    "clients",
    () => fetchClients(),
    { keepPreviousData: true }
  );

  const { isLoading, isError, data, error } = useQuery(
    ["customized_product", query.get("page")],
    () => fetchCustomizedOrders(),
    { keepPreviousData: true }
  );

  const onFilter = (e: any, filters: any, page: number) => {
    e?.preventDefault();
    console.log(filters.type);
    setFilterLoading(true);
    if (!filters.client && !filters.reference && !filters.type) {
      fetchCustomizedOrders();
      setFilterLoading(false);
    } else {
      let token = localStorage.getItem("token");
      return axiosInstance({
        method: "get",
        url: `/admin/search/customized_products?reference=${filterBy.reference}&ownerId=${filterBy.client}&type=${filterBy.type}&page=${page}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res: any) => {
        if (filters.type === 0) {
          setOrders(res.data);
          setFilterLoading(false);
        } else {
          serOrdersCancel(res.data);
          setFilterLoading(false);
        }
      });
    }
  };

  const { mutateAsync: deleteProduct, isLoading: deleteLoading } = useMutation(
    deleteCustomizedOrder,
    {
      onSuccess: () => {
        MyNotif("Product deleted successfully.", "success");
      },
    }
  );
  const { mutateAsync: restoreProduct, isLoading: restoreLoading } =
    useMutation(restoreCustomizedOrder, {
      onSuccess: () => {
        MyNotif("Order restored successfully.", "success");
      },
    });
  console.log(orders);

  return isLoading ? (
    <div
      className="loading_orders"
      style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <>
      <Collapse
        ghost
        expandIcon={() => (
          <FilterOutlined
            style={{ fontSize: 20, verticalAlign: 0, paddingTop: 8 }}
          />
        )}
      >
        <Panel header="Filter Orders" key="1">
          <form
            className="d-flex"
            onSubmit={(e: any) => onFilter(e, filterBy, 1)}
          >
            <Input
              type="text"
              className="w-50 mr-3 rounded"
              placeholder="Order reference"
              value={filterBy.reference}
              onChange={(e) =>
                setFilterBy({ ...filterBy, reference: e.target.value })
              }
            />
            <Select
              loading={loading}
              className="w-25 mr-3 select_filter_client"
              placeholder="Order sent by"
              value={+filterBy.client}
              onChange={(x: any) => setFilterBy({ ...filterBy, client: x })}
            >
              <Option value={0}>All clients</Option>
              {clients &&
                clients.data.data.map((client: any, i: number) => (
                  <Option value={client.id} key={i}>
                    {client.name}
                  </Option>
                ))}
            </Select>
            <Select
              loading={loading}
              className="w-25 mr-3 select_filter_client"
              placeholder="Order type"
              value={+filterBy.type}
              onChange={(x: any) => setFilterBy({ ...filterBy, type: x })}
            >
              <Option value={0}>All</Option>
              <Option value={6}>Product Cancelled</Option>
              <Option value={7}>Product Closed</Option>
            </Select>
            <div className="w-25 d-flex">
              <Input
                type="submit"
                value="Filter"
                className="w-50 rounded mr-2"
              />
              <Input
                type="reset"
                value="Clear"
                className="w-50 rounded"
                onClick={(e: any) => {
                  onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                  setFilterBy({ reference: "", client: 0, type: 0 });
                }}
              />
            </div>
          </form>
        </Panel>
      </Collapse>
      {filterBy.type === 0 ? (
        <>
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : orders && orders.data.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Order Ref</th>
                  <th>Client</th>
                  {/*               <th>Product Count</th>
                   */}{" "}
                  <th>Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders &&
                  orders.data.map((order: any, i: number) => (
                    <tr key={i}>
                      <td>{order?.ref || order?.reference}</td>
                      <td className="d-flex">
                        <div className="d-flex align-items-center">
                          <a
                            key={order.id}
                            className="collab_profile mr-2"
                            style={{
                              backgroundImage: `url(${
                                order.client.logo
                                  ? process.env.REACT_APP_STORAGE_URL +
                                    order.client.logo
                                  : avatar
                              })`,
                            }}
                            //   replace id with the collaborator name
                            id={order.client.name}
                          ></a>
                          <p className="mb-0">{order.client.name}</p>
                        </div>
                      </td>
                      {/*  <td>
                     <p className="mb-0">{order.name}</p> 
                    <p className="mb-0">
                      {order.count_product}
                      {order.count_product > 1 ? " products" : " product"}
                    </p>
                  </td> */}
                      <td>
                        <p className="mb-0">
                          {moment(order.updated_at).format("MMMM DD YYYY")}
                        </p>
                      </td>
                      <td>
                        <Link
                          to={`${history.location.pathname}/${
                            order.order_id || order.id
                          }`}
                        >
                          See Details
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      defaultCurrent={orders && orders.current_page}
                      defaultPageSize={10}
                      total={orders && orders.total}
                      hideOnSinglePage
                      responsive
                      onChange={(page: any) =>
                        !filterBy.client && !filterBy.client
                          ? history.push(
                              `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                            )
                          : onFilter(null, filterBy, page)
                      }
                    />
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      ) : filterBy.type === 6 ? (
        <>
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : ordersCancel && ordersCancel.data.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Client</th>

                  <th>Delete Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ordersCancel &&
                  ordersCancel.data.map((order: any, i: number) => (
                    <tr key={i}>
                      <td>{order.name}</td>
                      <td>{order.client.name}</td>

                      <td>
                        <p>{moment(order.updated_at).format("MMMM DD YYYY")}</p>
                      </td>
                      <td>
                        <div>
                          <Popconfirm
                            placement="top"
                            title={
                              "Are you sure you want to delete this order ?"
                            }
                            onConfirm={() => deleteProduct(order.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              type="ghost"
                              size={"middle"}
                              className="mr-2"
                              style={{ borderRadius: "4px" }}
                              icon={
                                <DeleteOutlined style={{ color: "#00468c" }} />
                              }
                              loading={deleteLoading}
                            >
                              Delete
                            </Button>
                          </Popconfirm>
                          <Popconfirm
                            placement="top"
                            title={
                              "Are you sure you want to restore this order ?"
                            }
                            onConfirm={() => restoreProduct(order.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              size={"middle"}
                              style={{ borderRadius: "4px" }}
                              icon={
                                <InboxOutlined
                                  style={{
                                    color: "#00468c",
                                    verticalAlign: "1px",
                                  }}
                                />
                              }
                              loading={restoreLoading}
                            >
                              Restore
                            </Button>
                          </Popconfirm>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    {/*     <Pagination
                      defaultCurrent={orders && orders.current_page}
                      defaultPageSize={10}
                      total={orders && orders.total}
                      hideOnSinglePage
                      responsive
                      onChange={(page: any) =>
                        !filterBy.client && !filterBy.client
                          ? history.push(
                              `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                            )
                          : onFilter(null, filterBy, page)
                      }
                    /> */}
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      ) : (
        <>
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : ordersCancel && ordersCancel.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Client</th>
                  <th>Quantity</th>
                  <th>Delivery Date</th>
                </tr>
              </thead>
              <tbody>
                {ordersCancel &&
                  ordersCancel.map((order: any, i: number) => (
                    <tr key={i}>
                      <td>{order.name}</td>
                      <td>{order.client.name}</td>
                      <td>{order.orders_status.qty}</td>
                      <td>
                        {moment(order.orders_status.delivery_date).format(
                          "MMMM DD YYYY"
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    {/*     <Pagination
                    defaultCurrent={orders && orders.current_page}
                    defaultPageSize={10}
                    total={orders && orders.total}
                    hideOnSinglePage
                    responsive
                    onChange={(page: any) =>
                      !filterBy.client && !filterBy.client
                        ? history.push(
                            `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                          )
                        : onFilter(null, filterBy, page)
                    }
                  /> */}
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default CustomizedOrdersCompany;
